var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main permission-denied"},[_c('v-container',{staticClass:"pb-10"},[_c('h1',[_vm._v("You do not have permissions")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }